import React from 'react';
import { Link } from 'react-router-dom';
import OIP from "../assets/OIP.jpg";
import "../styles/Developers.css";

export const Haoyang = () => {
    return(
        <div className="developer-profile-container">
            <h1 className="developer-header">About Haoyang</h1>
            <img src={OIP} alt="Haoyang's Portrait" className="developer-image" />
            <p className="developer-bio">
                Haoyang is a senior student in University at Buffalo studying Computer Science.
                He brings his experience and knowledge to the team, contributing to the 
                development of our application's core features and functionality.
            </p>
            <Link to="/about" className="back-button">Back to Developers</Link>
        </div>
    );
};
